import { createAction } from 'redux-actions';

import {
  UPDATE_APPOINTMENT_NOTE,
  UPDATE_APPOINTMENT_NOTE_ERROR,
  UPDATE_APPOINTMENT_NOTE_SUCCESS,
  UPDATE_APPOINTMENT_NOTE_AND_CREATE_ACCOUNT,
  UPDATE_APPOINTMENT_NOTE_AND_CREATE_ACCOUNT_ERROR,
  UPDATE_APPOINTMENT_NOTE_AND_CREATE_ACCOUNT_SUCCESS,
} from './type';

export const updateAppointmentNoteAction = createAction(
  UPDATE_APPOINTMENT_NOTE,
);
export const updateAppointmentNoteErrorAction = createAction(
  UPDATE_APPOINTMENT_NOTE_ERROR,
);
export const updateAppointmentNoteSuccessAction = createAction(
  UPDATE_APPOINTMENT_NOTE_SUCCESS,
);

export const updateAppointmentNoteAndCreateAccountAction = createAction(
  UPDATE_APPOINTMENT_NOTE_AND_CREATE_ACCOUNT,
);
export const updateAppointmentNoteAndCreateAccountErrorAction = createAction(
  UPDATE_APPOINTMENT_NOTE_AND_CREATE_ACCOUNT_ERROR,
);
export const updateAppointmentNoteAndCreateAccountSuccessAction = createAction(
  UPDATE_APPOINTMENT_NOTE_AND_CREATE_ACCOUNT_SUCCESS,
);
